export default "__VITE_ASSET__DOaOdIhM__"